import React from 'react';
import { useBrand } from 'contexts/BrandContext';
import { useWhiteLabel } from 'contexts/WhiteLabelContext';
import { Box, Stack, Typography } from '@mui/material';

/**
 * The links that used to live here belonged to Simmmple, who made the admin
 * template this dashboard was built from: "Support" opened a mail to their
 * address, "License" and "Terms of Use" went to their legal pages, "Blog"
 * to their blog.
 *
 * On a product being sold to other people that is worse than untidy — it
 * sends a paying customer to another company for help with yours. Removed
 * rather than repointed, because TechProOne has no support or terms pages
 * yet and a link to a 404 is not an improvement.
 */
export default function Footer() {
  const whiteLabel = useWhiteLabel();
  const { brandList, selectedBrand } = useBrand();

  /**
   * On a brand's own domain the copyright is the brand's.
   *
   * Our name in the footer of a dashboard the brand's staff open every day,
   * on the brand's own domain, is the single most visible place the
   * white-label promise would break — and a footer is exactly where people
   * look to find out whose software this is.
   */
  const brand = whiteLabel.active
    ? (brandList || []).map((b) => b.brand_id).find((b) => b?._id === selectedBrand)
    : null;
  const owner = whiteLabel.active ? (brand?.name || whiteLabel.brand?.name || '') : 'TechProOne';

  return (
    <Stack
      direction={{ xs: 'column', xl: 'row' }}
      alignItems={{ xs: 'center', xl: 'flex-start' }}
      justifyContent='space-between'
      sx={{ zIndex: 3, px: { xs: '30px', md: '50px' }, pb: '30px' }}
    >
      <Typography
        color='text.secondary'
        textAlign={{ xs: 'center', xl: 'start' }}
        mb={{ xs: '20px', xl: '0px' }}
      >
        © {new Date().getFullYear()}
        <Box component='span' sx={{ fontWeight: 500, ml: '4px' }}>
          {owner ? `${owner} All Rights Reserved.` : 'All Rights Reserved.'}
        </Box>
      </Typography>
    </Stack>
  );
}
